import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'residence-box',
    templateUrl: './residence-box.component.html',
    styleUrls: ['./residence-box.component.scss'],
    standalone: false
})
export class ResidenceBoxComponent implements OnInit {
  @Input() title = '';
  @Input() suffix = '';
  @Input() svg = '';
  @Input() checked = false;
  isBoxFocused: boolean = false;
  constructor() {}

  ngOnInit() {}
}
